import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cardName',
  standalone: true
})
export class CardNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    
    const cleaned = value.replace(/[^a-zA-Z\s]/g, '');
    
    const upperCased = cleaned.toUpperCase();
    
    const normalized = upperCased
      .replace(/\s{2,}/g, ' ')
      .replace(/^\s+|\s+$/g, '');
    
    return normalized;
  }
}
